import '../Sass/App.scss';
import React, { useContext } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { MWContext } from '../Contexts/MWContext';
import { CartContext } from '../Contexts/CartContext';

function componentList(components) {
    return String(components || '')
        .split(',')
        .map((component) => component.trim())
        .filter(Boolean);
}

function formatPrice(price) {
    return `$${Number(price || 0).toFixed(2)}`;
}

export function CodebaseItem(props) {

    const { IMAGE_ROOT } = useContext(MWContext)
    const cart = useContext(CartContext)
    const inCart = cart.isInCart(props.codebase.codebase_id)
    const canPlaytest = Boolean(props.codebase.can_playtest)
    const components = componentList(props.codebase.components)

    function assetUrl(path) {
        if (!path) {
            return '';
        }

        if (/^(https?:\/\/|data:image\/)/i.test(path)) {
            return path;
        }

        if (path.startsWith('/game_assets/')) {
            return IMAGE_ROOT.replace(/\/game_assets\/?$/, '') + path;
        }

        return IMAGE_ROOT + '/' + path.replace(/^\/+/, '');
    }

    function getCardStyle() {
        const featuredImage = assetUrl(props.codebase.featured_image);

        return {
            backgroundImage: featuredImage ? 'url(' + featuredImage + ')' : 'none'
        }
    }

    function viewDocumentation() {
        if (props.changePage) {
            props.changePage('documentation', props.codebase.codebase_id);
        }
    }

    function playtestCodebase() {
        if (props.changePage && canPlaytest) {
            props.changePage('playtest engine', props.codebase.codebase_id);
        }
    }

    return (
        <div className='shop-box' style={getCardStyle()}>
            <div className='shop-box-content'>
                <Grid container spacing={2}>
                    <Grid xs={6} lg={9}>
                        <h1>{props.codebase.name}</h1>
                        <div className='green-code'>{props.codebase.description}</div>                        
                    </Grid>
                    <Grid style={{ textAlign: 'right' }} xs={6} lg={3}>
                        <span className="component-tag component-tag-price">{formatPrice(props.codebase.price)}</span>
                        {components.map((component) =>
                            <span className="component-tag" key={component}>{component}</span>
                        )}
                    </Grid>
                    <Grid xs={12}>
                        <button className="cli-button" onClick={viewDocumentation}>documentation</button>
                        <button className={inCart ? "cli-button-white" : "cli-button"} onClick={() => cart.addCodebase(props.codebase)}>
                            {inCart ? 'in cart' : 'add to cart'}
                        </button>
                        <button className="cli-button" onClick={playtestCodebase} disabled={!canPlaytest}>
                            {canPlaytest ? 'playtest' : 'playtest locked'}
                        </button>                        
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}
